// "Recent audits" panel on the admin dashboard. Verbatim from AdminDashboard.jsx (W2d).
// Each row is a Link to /admin/audits/:sid.
import { Link } from "react-router-dom";

export default function RecentAuditsList({ recentAudits }) {
  return (
    <div className="sf-card" data-testid="recent-audits-card">
      <div className="sf-eyebrow" style={{ marginBottom: 10 }}>Recent audits</div>
      {recentAudits.length === 0 && <div className="sf-muted-text" style={{ fontSize: 13 }}>No audits yet.</div>}
      {recentAudits.map((a) => (
        <Link
          key={a.session_id}
          to={`/admin/audits/${a.session_id}`}
          className="sf-mono"
          style={{ display: "block", fontSize: 12, padding: "8px 0", borderBottom: "1px dashed #22262B", textDecoration: "none", color: "var(--sf-offwhite)" }}
          data-testid={`recent-audit-${a.session_id}`}
        >
          <div>{a.business_name || <span className="sf-muted-text">(no name)</span>}</div>
          <div className="sf-muted-text" style={{ fontSize: 11 }}>
            {a.business_type} · score {a.score ?? "—"} · {a.paid ? "PAID" : "free"}
          </div>
        </Link>
      ))}
    </div>
  );
}
